import { useIntl, defineMessages } from 'react-intl';
import type { FormValues } from '../types';
import { InputIDs } from '../types';
import { rateProtectionFormSchema } from '../helpers/validationSchema';
import { GeneralForm } from '../GeneralForm';
import { formatDate } from '../../../utils';
import { requiredFields, toPrefill, usedFields } from './settings';

const rateProtectionMessages = defineMessages({
  submit: {
    id: 'forms.rateProtection.submit',
    defaultMessage: 'Jetzt kostenpflichtig bestellen',
  },
  submitDisabled: {
    id: 'forms.rateProtection.submit.disabled',
    defaultMessage: 'Bitte fülle zuerst das Formular aus',
  },
  sucessHeadline: {
    id: 'forms.rateProtection.success.headline',
    defaultMessage: 'Vielen Dank!',
  },
  sucessDescription: {
    id: 'forms.rateProtection.success.description',
    defaultMessage:
      'Deine Angaben wurden erfolgreich übermittelt. Wir bearbeiten deine Anfrage schnellstmöglich und senden dir in Kürze deine Unterlagen zu.',
  },
  messageFieldLabel: {
    id: 'forms.rateProtection.messageFieldLabel',
    defaultMessage: 'Bemerkung',
  },
});

/* Reference of Post Body:
  ------------------------------------------------------
  {
    "subject": "my 'Subject for this email",
    "message": "My very important message, I have to say",
    "customerData": {
      "firstName": "MyFirstname",
      "lastName": "MyLastName",
      "customerId": "anIdMaybeNumbers",
      "street": "MyStreet",
      "housenumber": "2B",
      "city": "My-City",
      "postalCode": "12345",
      "emailAddress": "mymail@example.com",
      "phoneNumber": "01012345",
      "salutation": "female",
      "dateOfBirth": "1980-03-20"
    }
    "messageType": "RSV"
  }
  */
export const convertFormDataToPostData = (formValues: FormValues) => {
  const salutation = formValues[InputIDs.SALUTATION];
  const dateOfBirth = formValues[InputIDs.BIRTHDAY];

  return {
    subject: '',
    message: formValues[InputIDs.MESSAGE] || '',
    customerData: {
      firstName: formValues[InputIDs.FIRSTNAME] || '',
      lastName: formValues[InputIDs.LASTNAME] || '',
      customerId: formValues[InputIDs.CUSTOMERID] || '',
      street: formValues[InputIDs.STREET] || '',
      housenumber: formValues[InputIDs.HOUSENUMBER] || '',
      city: formValues[InputIDs.CITY] || '',
      postalCode: formValues[InputIDs.POSTALCODE] || '',
      emailAddress: formValues[InputIDs.EMAIL] || '',
      phoneNumber: formValues[InputIDs.PHONENUMBER] || '',
      ...(dateOfBirth &&
        dateOfBirth !== '' && {
          dateOfBirth: formatDate(dateOfBirth),
        }),
      ...(salutation &&
        salutation !== 'notSpecified' && {
          salutation,
        }),
    },
    messageType: 'RSV' as const,
  };
};

const RateProtectionForm = () => {
  const intl = useIntl();

  return (
    <GeneralForm
      initialValues={usedFields}
      validationSchema={rateProtectionFormSchema}
      requiredFields={requiredFields}
      fieldsToPrefill={toPrefill}
      convertFormDataToPostData={convertFormDataToPostData}
      successPage={{
        headline: intl.formatMessage(rateProtectionMessages.sucessHeadline),
        description: intl.formatMessage(rateProtectionMessages.sucessDescription),
      }}
      submitButton={{
        enabled: intl.formatMessage(rateProtectionMessages.submit),
        disabled: intl.formatMessage(rateProtectionMessages.submitDisabled),
      }}
      customMessageField={{
        label: intl.formatMessage(rateProtectionMessages.messageFieldLabel),
        placeholder: '',
      }}
      showSalutation
      showTerms
      showBirthdate
    />
  );
};

// eslint-disable-next-line import/no-default-export
export default RateProtectionForm;
